/*
* API URLs
*/
export const XRPSCAN_API_URL = process.env.REACT_APP_XRPSCAN_API_URL;
export const XRPSCAN_WSS_URL = process.env.REACT_APP_XRPSCAN_WSS_URL;
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
export const XRPL_SERVER_VERSIONS = [process.env.REACT_APP_XRPL_SERVER_VERSIONS];
export const NETWORK_ID = Number(process.env.REACT_APP_NETWORK_ID);
export const NETWORK_NAME = process.env.REACT_APP_NETWORK_NAME;